const templates = [
    {
        'id': 0,
        'template': '{{Sentence A}} Furthurmore, {{Sentence B}}',
    },
    {
        'id': 1,
        'template': '{{Sentence A}} In particular, {{Sentence B}}',
    },
    {
        'id': 2,
        'template': '{{Sentence A}} Specially, {{Sentence B}}',
    },
]

export default templates;